//
//
//


export default {
  name: 'IndexPage',
  beforeMount() {
    window.location = '/home';
  },
  
  data() {
    return {
      apis: [],
    };
  },
}
